import config from '../../../config/config';
import getRequest from '../base/get';

export default {
  /**
   * Fetch eMSP CDR by ID
   * @param {string} id - The CDR ID
   * @returns {Promise<any>} The API response
   */
  fetchEmspCdrById: (id: string): Promise<any> => {
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/${id}`);
  },
  /**
   * Fetch eMSP CDR details by session ID
   * @param {string} sessionId - The session ID
   * @returns {Promise<any>} The API response
   */
  fetchEmspCdrDetailsBySessionId: (sessionId: string): Promise<any> => {
    return getRequest(
      `${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/session/${sessionId}/details`,
    );
  },
};

